import React, { Component } from "react"
import ProgressBar from "../../artzu-ui/src/ProgressBar"
import { Link } from 'react-router-dom';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import Loading from '../shared/Loading';

const query = gql`
        query promoWidget {
            currentUser {
              id
              hoursThisWeek
              bookingsThisWeek
            }
          }
        `;
class PromoWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }
  render() {
    const { status } = this.props;
    return (
      <Query
        query={query}
        fetchPolicy='network-only'
      >
        {({ loading, error, data, refetch }) => {
          if (status === "weekly_lease") return null;
          if (loading) return <div className="load-div"><Loading size="3x" /></div>;
          const bookedHours = data.currentUser.bookingsThisWeek;
          const hoursDriven = data.currentUser.hoursThisWeek;
          const showMaxPromo = bookedHours >= 50;
          const bookedProgress = bookedHours * 100 / (showMaxPromo ? 80 : 50)
          const driveProgress = hoursDriven * 100 / (showMaxPromo ? 80 : 50) 
          return (
            <div className="promo-widget">
              <div className="dash-top">
                <p>Promotions</p>
                <Link to="/promotions">See All</Link>
              </div>
              <p className="promo-notice">Drive {showMaxPromo ? '80' : '50'} hours a week and receive <strong>${showMaxPromo ? '100' : '50'} credit</strong></p>
              <div className="progress-display">
                <ProgressBar 
                  fillers={[
                    bookedProgress === 0 ? 0 : (Math.max(Math.min(bookedProgress, 100), 12)), 
                    driveProgress === 0 ? 0 : (Math.max(Math.min(driveProgress, 100), 12))
                    ]} 
                  className="widget-pbar" 
                  borderColor="#414141" 
                  primaryColor="#414141" 
                  secondaryColor="#128dff" />
                <p>{bookedHours}/{bookedHours >= 50 ? '80' : '50'}</p>
              </div>
            </div>
          )
        }}
      </Query>
    )
  }
}

export default PromoWidget;


// WEBPACK FOOTER //
// ./src/components/NewDash/PromoWidget.js